import { useGate } from '@lib/state-engine';
import { useSearchParams } from '@lib/routing-engine';
import { WarehouseViewer } from './warehouse-viewer';
import { WarehouseDetalization } from './warehouse-detalization';
import { ViewerGate } from './model';
import {
  WAREHOUSES_BAGS_QUERY_NAME,
  WAREHOUSES_ID_QUERY_NAME,
  WAREHOUSES_TYPE_QUERY_NAME,
} from '@@/warehouses/config/query.config';

import styles from './styles.module.css';

export const StorageViewer = () => {

  const [searchParams] = useSearchParams();

  useGate(ViewerGate, {
    wh: searchParams.get(WAREHOUSES_ID_QUERY_NAME),
    z: searchParams.get(WAREHOUSES_TYPE_QUERY_NAME),
  });

  return (
    <div className={styles.storageViewer}>
      <WarehouseViewer />
      <WarehouseDetalization />
    </div>
  );
};
